import { ReactElement } from 'react';
import { Collapse } from 'antd';
import type { Branch } from '../types';
import AdvertisementPanelLabel from './AdvertisementPanelLabel';
import ForwardDestinationToggle from './ForwardDestinationToggle';
import JobNumberList from './JobNumberList';
import ScheduleEditor from './ScheduleEditor';
import { CollapseWrapper, EmptyHint, SectionHeading, SubSection } from './styles';

interface Props {
  branch: Branch;
}

const BranchSection = ({ branch }: Props): ReactElement => {
  const { code, canForwardToTokyo, advertisements } = branch;
  const items = advertisements.map(advertisementCode => ({
    key: advertisementCode,
    label: <AdvertisementPanelLabel advertisementCode={advertisementCode} />,
    children: <JobNumberList advertisementCode={advertisementCode} />,
  }));

  return (
    <>
      <SubSection>
        <ScheduleEditor branchCode={code} />
      </SubSection>
      {canForwardToTokyo && (
        <SubSection>
          <ForwardDestinationToggle branchCode={code} />
        </SubSection>
      )}
      <SubSection>
        <SectionHeading>自動架電対象の仕事No</SectionHeading>
        {advertisements.length === 0 ? (
          <EmptyHint>広告コードが登録されていません</EmptyHint>
        ) : (
          <CollapseWrapper>
            <Collapse items={items} />
          </CollapseWrapper>
        )}
      </SubSection>
    </>
  );
};

export default BranchSection;
